/**
 * Browser (non-Electron) OpenAPI.BASE selection for Vite.
 * - Localhost / 127.0.0.1: set BASE only when VITE_API_BASE_URL is a non-empty string;
 *   otherwise return undefined so the generated-client default stays.
 * - Other hosts: return "" (relative / same-origin), matching historical SPA deploy behavior.
 */
export function resolveLocalViteOpenApiBase(
  pageHref: string,
  viteApiBaseUrl: unknown
): string | undefined {
  const isLocalHost =
    pageHref.includes("localhost") || pageHref.includes("127.0.0.1");

  if (!isLocalHost) {
    return "";
  }

  if (typeof viteApiBaseUrl === "string" && viteApiBaseUrl.trim() !== "") {
    return viteApiBaseUrl.trim();
  }

  return undefined;
}
